<template>

	<div class="check-list">
		<ul>
			<slot name="listItems" />
		</ul>
	</div>

</template>

<script>

	export default {
		name: "CheckList"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "responsive-font.scss";

	.check-list {
		// max-width:47.3rem;
		ul {
			@include list-style-reset;
			@include media(large) {
				padding-left:3rem;
			}
			li {
				position:relative;
				&:before {
					@include media(large) {
						content:url(~img/checkmark.svg); position:absolute; top:0; left:-3rem; font-size:1rem;
					}
				}
				&:first-child {
					h3 {
						margin-top:0;
					}
				}
			}
		}
		h3 {
			@include responsive-font(20);
			color:#3D3D3D; font-weight:600; line-height:1.25; font-family:'proxima-nova'; margin-top:3vw;
		}
		p {
			color:#6D6E71; margin:.5vw 0 0;
			@include media(xxlarge) {
				margin:.8rem 0 0;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/CheckList.vue